module.exports = __webpack_public_path__ + "src/assets/textures/env/barn/barn_door_02_1k_bake.png";